/**
 * Checks if a given URL is an external link using a regular expression.
 * This implementation is based on the provided reference.
 *
 * @param url The URL string to check.
 * @returns True if the URL is an external link, false otherwise.
 */
export const isExternalUrl = (url: string | undefined | null): boolean => {
  if (!url) {
    return false;
  }

  // Check if the URL starts with "http" or "https" (case-insensitive)
  const startsWithHttp = /^http/i.test(url);

  // Check if the URL does NOT match the current hostname (case-insensitive)
  const isNotSameHostname = !new RegExp(
    `^http(s)?://${window.location.hostname}`,
    'i',
  ).test(url);

  return startsWithHttp && isNotSameHostname;
};
